module.exports = __webpack_public_path__ + "img/hospital9.c7983e04.png";